module.exports = __webpack_public_path__ + "static/media/github.c7f4f8cd.svg";